<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <!-- Widgets-->
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="shopping_cart"
          title="Orders"
          subTitle="15,785"
          :supTitle="$t('widgetTodaysVisit')"
          color="primary"
          variant="#30ADAD"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="credit_card"
          title="REVENUE"
          subTitle="£100,250"
          :supTitle="$t('widgetTodaysSale')"
          color="orange"
          variant="#F08282"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="picture_in_picture"
          title="AVG ORDER"
          subTitle="£32.50"
          :supTitle="$t('widgetUniqueVisits')"
          color="purple"
          variant="#7891FF"
        />
      </v-flex>
      <v-flex d-flex lg3 sm6 xs12>
        <widget
          icon="shopping_basket"
          title="AVG BASKET"
          :subTitle="2.5"
          :supTitle="$t('widgetBounceRate')"
          color="dark-blue"
          variant="#29417B"
        />
      </v-flex>
      <!-- Widgets Ends -->
      <!-- Statistics -->
      <v-flex d-flex lg6 sm6 xs12>
        <site-view-statistic class="w-100" />
      </v-flex>
      <v-flex d-flex lg6 sm6 xs12>
        <location-statistic class="w-100" />
      </v-flex>
      <!-- Statistics Ends -->
      <!-- DataTable&TimeLine Starts -->
      <!-- <v-flex d-flex lg12 sm6 xs12> <data-table class="w-100" /> </v-flex> -->

      <!-- DataTable&TimeLine Ends -->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      lorem: `Lorem ipsum dolor sit amet, mel at clita quando.`
    };
  }
};
</script>

<style>
.w-100 {
  width: 100%;
}
</style>
